import angular from 'angular';

const projectSelectorService = angular.module('ttb.services.project-selector.service', [])
    .factory('ProjectSelectorService', ['$resource',
        function ($resource) {
            return $resource('/api/project/', {}, {
                selector: {url: '/api/configuration/project/selector', method: 'GET', isArray: true}
            });
        }])
    .name;

export default projectSelectorService;


// WEBPACK FOOTER //
// ../services/project-selector.service.js